"use client";

import { SessionProvider } from "next-auth/react";
import SessionTimeoutManager from "./SessionTimeoutManager";

export default function AppSessionProvider({ children }) {
  return (
    <SessionProvider
      basePath="/api/auth"
      refetchInterval={60}
      refetchOnWindowFocus
    >
      <SessionTimeoutManager />
      {children}
    </SessionProvider>
  );
}
